

<template>
  <div class="row">
    <div class="col-md-6">
      <vuestic-widget class="chart-widget" :headerText="'vmGraphs.cpuUsage' | translate">
        <div v-if="load===false" class="d-flex justify-content-center">
          <semipolar-spinner :animation-duration="2000" :size="100" :color="palette.primary" />
        </div>
        <vuestic-simple-select
          v-if="load"
          class="float-right"
          :label="'vmGraphs.periodSelect' | translate"
          v-model="timeframeModel"
          option-key="description"
          v-bind:options="timeframes"
        ></vuestic-simple-select>
        <vuestic-chart v-if="load" :data="cpuDataset" type="line" :options="cpuOptions"></vuestic-chart>
      </vuestic-widget>
    </div>
    <div class="col-md-6">
      <vuestic-widget class="chart-widget" :headerText="'vmGraphs.memUsage' | translate">
        <div v-if="load===false" class="d-flex justify-content-center">
          <semipolar-spinner :animation-duration="2000" :size="100" :color="palette.primary" />
        </div>
        <vuestic-simple-select
          v-if="load"
          class="float-right"
          :label="'vmGraphs.periodSelect' | translate"
          v-model="timeframeModel"
          option-key="description"
          v-bind:options="timeframes"
        ></vuestic-simple-select>
        <vuestic-chart v-if="load" :data="memDataset" type="line" :options="memOptions"></vuestic-chart>
      </vuestic-widget>
    </div>
    <div class="col-md-6">
      <vuestic-widget class="chart-widget" :headerText="'vmGraphs.nicUsage' | translate">
        <div v-if="load===false" class="d-flex justify-content-center">
          <semipolar-spinner :animation-duration="2000" :size="100" :color="palette.primary" />
        </div>
        <vuestic-simple-select
          v-if="load"
          class="float-right"
          :label="'vmGraphs.periodSelect' | translate"
          v-model="timeframeModel"
          option-key="description"
          v-bind:options="timeframes"
        ></vuestic-simple-select>
        <vuestic-chart v-if="load" :data="nicDataset" type="line" :options="nicOptions"></vuestic-chart>
      </vuestic-widget>
    </div>
    <div class="col-md-6">
      <vuestic-widget class="chart-widget" :headerText="'vmGraphs.diskUsage' | translate">
        <div v-if="load===false" class="d-flex justify-content-center">
          <semipolar-spinner :animation-duration="2000" :size="100" :color="palette.primary" />
        </div>
        <vuestic-simple-select
          v-if="load"
          class="float-right"
          :label="'vmGraphs.periodSelect' | translate"
          v-model="timeframeModel"
          option-key="description"
          v-bind:options="timeframes"
        ></vuestic-simple-select>
        <vuestic-chart v-if="load" :data="diskDataset" type="line" :options="diskOptions"></vuestic-chart>
      </vuestic-widget>
    </div>
  </div>
</template>

<script>
import ajax from 'services/ajax'
import utils from 'services/utils'
import time from 'services/time'
import store from 'vuex-store'
import moment from 'moment'
import { SemipolarSpinner } from 'epic-spinners'
import { mapGetters } from 'vuex'

let palette = store.getters.palette

export default {
  props: {
    vm: {
      type: Object,
      required: true
    }
  },
  components: {
    SemipolarSpinner
  },
  computed: {
    ...mapGetters(['palette'])
  },
  data () {
    return {
      load: false,
      timeframes: [
        { 'id': 'hour', description: this.$t('vmGraphs.hour') },
        { 'id': 'day', description: this.$t('vmGraphs.day') },
        { 'id': 'week', description: this.$t('vmGraphs.week') },
        { 'id': 'month', description: this.$t('vmGraphs.month') },
      ],
      timeframeModel: {},

      labels: [],
      cpuDataset: {
        labels: [],
        datasets: [
          {
            label: this.$t('vmGraphs.cpuUsage'),
            backgroundColor: utils.hex2rgb(palette.primary, 0.6).css,
            borderColor: palette.transparent,
            data: []
          }
        ],
      },
      memDataset: {
        labels: [],
        datasets: [
          {
            label: this.$t('vmGraphs.memUsage'),
            backgroundColor: utils.hex2rgb(palette.info, 1.0).css,
            borderColor: palette.transparent,
            data: []
          },
          {
            label: this.$t('vmGraphs.memTotal'),
            backgroundColor: utils.hex2rgb(palette.primary, 0.6).css,
            borderColor: palette.transparent,
            data: []
          }
        ],
      },
      nicDataset: {
        labels: [],
        datasets: [
          {
            label: this.$t('vmGraphs.nicIn'),
            backgroundColor: utils.hex2rgb(palette.primary, 0.6).css,
            borderColor: palette.transparent,
            data: []
          },
          {
            label: this.$t('vmGraphs.nicOut'),
            backgroundColor: utils.hex2rgb(palette.info, 0.6).css,
            borderColor: palette.transparent,
            data: []
          }
        ],
      },
      diskDataset: {
        labels: [],
        datasets: [
          {
            label: this.$t('vmGraphs.diskWrite'),
            backgroundColor: utils.hex2rgb(palette.primary, 0.6).css,
            borderColor: palette.transparent,
            data: []
          },
          {
            label: this.$t('vmGraphs.diskRead'),
            backgroundColor: utils.hex2rgb(palette.info, 0.6).css,
            borderColor: palette.transparent,
            data: []
          }
        ],
      },
      cpuOptions: {
        elements: {
          point: {
            radius: 0,
            hoverRadius: 4,
            hitRadius: 8
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              // Include a dollar sign in the ticks
              callback: function (value, index, values) {
                return value + '%'
              },
            }
          }],
          xAxes: [{
            ticks: {
              autoSkip: true,
              maxTicksLimit: 10
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItems, data) {
              return data.datasets[tooltipItems.datasetIndex].label + ': ' + tooltipItems.yLabel + '%'
            }
          }
        }
      },
      memOptions: {
        elements: {
          point: {
            radius: 0,
            hoverRadius: 4,
            hitRadius: 8
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              // Include a dollar sign in the ticks
              callback: function (value, index, values) {
                return value + ' GB'
              },
            }
          }],
          xAxes: [{
            ticks: {
              autoSkip: true,
              maxTicksLimit: 10
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItems, data) {
              return data.datasets[tooltipItems.datasetIndex].label + ': ' + tooltipItems.yLabel + ' GB'
            }
          }
        }
      },
      nicOptions: {
        elements: {
          point: {
            radius: 0,
            hoverRadius: 4,
            hitRadius: 8
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              // Include a dollar sign in the ticks
              callback: function (value, index, values) {
                return value + ' KB/s'
              },
            }
          }],
          xAxes: [{
            ticks: {
              autoSkip: true,
              maxTicksLimit: 10
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItems, data) {
              return data.datasets[tooltipItems.datasetIndex].label + ': ' + tooltipItems.yLabel + ' KB/s'
            }
          }
        }
      },
      diskOptions: {
        elements: {
          point: {
            radius: 0,
            hoverRadius: 4,
            hitRadius: 8
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              // Include a dollar sign in the ticks
              callback: function (value, index, values) {
                return value + ' KB'
              },
            }
          }],
          xAxes: [{
            ticks: {
              autoSkip: true,
              maxTicksLimit: 10
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItems, data) {
              return data.datasets[tooltipItems.datasetIndex].label + ': ' + tooltipItems.yLabel + ' KB'
            }
          }
        }
      }
    }
  },
  watch: {
    timeframeModel: function (val) {
      this.rrddata()
    }
  },
  methods: {
    cleanDataset () {
      this.load = false
      this.labels = []
      this.cpuDataset.datasets[0].data = []
      this.memDataset.datasets[0].data = []
      this.memDataset.datasets[1].data = []
      this.nicDataset.datasets[0].data = []
      this.nicDataset.datasets[1].data = []
      this.diskDataset.datasets[0].data = []
      this.diskDataset.datasets[1].data = []
    },
    rrddata () {
      this.cleanDataset()
      ajax.run(this, 'customer/vms/' + this.vm.hosting_id + '/rrddata?timeframe=' + this.timeframeModel.id, (data) => {
        data.data.forEach((item, index) => {
          if (typeof item.cpu !== 'undefined') {
            var cpuUsage = Math.round(item.cpu * 100)
            this.cpuDataset.datasets[0].data.push(cpuUsage)
          } else {
            this.cpuDataset.datasets[0].data.push(0)
          }

          if (typeof item.mem !== 'undefined') {
            var memTotal = item.maxmem / Math.pow(1024, 3) // Convert to GB
            memTotal = memTotal.toFixed(1)
            this.memDataset.datasets[1].data.push(memTotal)

            var memUsage = item.mem / Math.pow(1024, 3) // Convert to GB
            memUsage = memUsage.toFixed(1)
            this.memDataset.datasets[0].data.push(memUsage)
          } else {
            this.memDataset.datasets[0].data.push(0)
            this.memDataset.datasets[1].data.push(0)
          }

          if (typeof item.netin !== 'undefined') {
            var nicIn = item.netin / Math.pow(1024, 1) // Convert to Kbps
            nicIn = Math.round(nicIn)
            this.nicDataset.datasets[0].data.push(nicIn)

            var nicOut = item.netout / Math.pow(1024, 1) // Convert to Kbps
            nicOut = Math.round(nicOut)
            this.nicDataset.datasets[1].data.push(nicOut)
          } else {
            this.nicDataset.datasets[0].data.push(0)
            this.nicDataset.datasets[1].data.push(0)
          }

          if (typeof item.diskwrite !== 'undefined') {
            var diskWrite = item.diskwrite / Math.pow(1024, 1) // Convert to MB
            diskWrite = Math.round(diskWrite)
            this.diskDataset.datasets[0].data.push(diskWrite)

            var diskRead = item.diskread / Math.pow(1024, 1) // Convert to MB
            diskRead = Math.round(diskRead)
            this.diskDataset.datasets[1].data.push(diskRead)
          } else {
            this.diskDataset.datasets[0].data.push(0)
            this.diskDataset.datasets[1].data.push(0)
          }

          if (typeof item.time !== 'undefined') {
            var timestamp = moment.unix(item.time)
            this.labels.push(time.convert(timestamp, 'datetime-min'))
          }
        })

        // Populate dataset labels

        this.cpuDataset.labels = this.labels
        this.memDataset.labels = this.labels
        this.nicDataset.labels = this.labels
        this.diskDataset.labels = this.labels

        // Load graphs
        this.load = true
      }, (error) => {
        console.log(error)
      })
    }
  },
  created () {
    this.timeframeModel = this.timeframes[0]
  }
}
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
</style>


// WEBPACK FOOTER //
// src/components/management/VmUsage.vue